import { useI18n } from 'vue-i18n'
import { availableLocales } from '~/i18n/config'

export const useLocale = () => {
  const { locale } = useI18n()
  const { $changeLanguage } = useNuxtApp()

  // 获取当前语言
  // locale is reactive; localStorage alone cannot invalidate a computed flag.
  const getCurrentLocale = () => locale.value

  // 设置语言
  const setLocale = (newLocale: string) => {
    // 验证语言是否支持
    if (!availableLocales.some(l => l.code === newLocale)) {
      console.warn(`Unsupported locale: ${newLocale}`)
      return false
    }

    // 使用全局提供的 changeLanguage 方法（无刷新切换）
    if ($changeLanguage(newLocale)) {
      // i18n 插件已经处理了语言切换，无需刷新页面
      return true
    }
    return false
  }

  // 初始化语言设置
  const initLocale = () => {
    if (process.client) {
      const savedLocale = localStorage.getItem('locale')
      if (savedLocale && availableLocales.some(l => l.code === savedLocale)) {
        // 初始化时不需要刷新页面
        if ($changeLanguage(savedLocale)) {
          return true
        }
      }
    }
    return false
  }

  return {
    getCurrentLocale,
    setLocale,
    initLocale,
    availableLocales
  }
} 